import $systemUseNotification from "./systemUseNotification.signal";

export const handleSystemAgreementClick = () => {
  localStorage.setItem('systemUseAgreement', true);

  $systemUseNotification.update({ show: false });
}